<template>
  <div style="background: #f8f8f8">
    <div class="banner">
      <div class="container">
        <div class="header-div">
          <h1 class="header-text">Help</h1>
          <img class="header-logo" src="../assets/images/logo.png" />
        </div>
      </div>
    </div>
    <section class="header-section">
      <div class="header-content">
        <h1 class="welcome-text">Welcome to nestease Help</h1>
        <p class="wlc-desc">
          Click on each feature below to learn what’s included. At the end,
          we’ll walk you through how to sign up in the app.
        </p>
      </div>
    </section>
    <section class="outdoor-service-section">
      <div class="outdoor-service outdoor-service-mob">
        <div class="outdoor-service-box container">
          <div class="outdoor-service-label">
            <span class="left"></span> OUTDOOR SERVICES
            <span class="right"></span>
          </div>
          <div v-if="loading" class="outdoor-service-grid">
            <div v-for="n in 6" :key="n" class="skeleton-card">
              <div class="skeleton skeleton-icon"></div>
              <div class="skeleton-content">
                <div class="skeleton skeleton-title"></div>
                <div class="skeleton skeleton-desc"></div>
              </div>
            </div>
          </div>
          <div v-else class="outdoor-service-grid">
            <div
              v-for="(service, idx) in outdoorServices"
              :key="service.title"
              class="outdoor-service-card"
              :class="{ 'disabled-card': !service.is_enable }"
              :style="{
                backgroundColor: service.is_enable ? 'white' : '#F8F8F8',
              }"
              @click="
                service.is_enable ? navigateToService(service, idx) : null
              "
            >
              <div class="outdoor-service-icon-bg" v-html="service.icon"></div>
              <div>
                <div class="outdoor-service-title">{{ service.title }}</div>
                <div class="outdoor-service-desc">{{ service.desc }}</div>
              </div>
            </div>
          </div>
          <button
            @click="toggleDropdown"
            class="about-us-btn about-us-btn-green outdoor-btn"
          >
            DOWNLOAD NOW!
          </button>
          <div v-if="isOpen" class="dropdown-menu" @click.stop>
            <div class="dropdown-menu-content">
              <a
                href="https://apps.apple.com/in/app/nestease/id1539350208"
                target="_blank"
              >
                <img
                  src="../assets/images/qr-ios.svg"
                  alt="App Store Badge"
                  class="store-badge"
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.nestease.customer"
                target="_blank"
              >
                <img
                  src="../assets/images/qr-android.svg"
                  alt="Google Play Badge"
                  class="store-badge"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="indoor-service">
        <div class="indoor-service-box">
          <div class="indoor-service-label">
            <span class="left"></span> INDOOR SERVICES
            <span class="right"></span>
          </div>
          <div class="indoor-service-grid">
            <div
              v-for="service in indoorServices.slice(0, 1)"
              :key="service.title"
              class="indoor-service-card"
            >
              <div
                class="indoor-service-icon-bg"
                :style="{ backgroundImage: `url(${service.icon})` }"
              ></div>
              <div>
                <div class="indoor-service-title">{{ service.title }}</div>
                <div class="indoor-service-desc">{{ service.desc }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="indoor-bottom-note">
          <p>Looking for a service not listed here?</p>
          <button
            type="button"
            class="btn btn-light contact-us"
            @click="onContactUs()"
          >
            Contact Us
          </button>
        </div>
      </div>
    </section>
    <section class="video-main-section">
      <div>
        <div class="video-header">
          <h2 class="video-title">Signup Video</h2>
        </div>
        <div class="video-content-section">
          <video id="videoPlayer" src="../assets/video/trainingVideoNew5.mp4" controls muted
            ref="videoPlayer" class="video-content"></video>
        </div>
      </div>
    </section>
    <section>
      <div class="promo-banner-container">
        <div class="promo-banner">
          <div class="promo-content">
            <h1 class="promo-banner-title">
              10% Off All 2025 Lawn Mowing Services
            </h1>
            <p class="tagline">YOUR NEED. YOUR TIME. YOUR CHOICE</p>
            <p class="service-decs">Service just 2 clicks away</p>
            <p class="service-decs">
              Download the app now to lock in your discount.
            </p>
            <div class="app-buttons">
              <a
                href="https://apps.apple.com/in/app/nestease/id1539350208"
                target="_blank"
              >
                <img
                  src="../assets/images/apple-store-ligth.svg"
                  alt="Download on App Store"
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.nestease.customer"
                target="_blank"
              >
                <img
                  src="../assets/images/playstore-ligth.svg"
                  alt="Get it on Google Play"
                />
              </a>
            </div>
          </div>
          <div class="phone-mockup">
            <img
              class=""
              src="../assets/images/splash-mockup.svg"
              alt="Phone Mockup"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { db } from "../firebase/config";
import { collection, getDocs, doc, getDoc } from "firebase/firestore";
export default {
  props: ["autoplay"],
  watch: {
    autoplay(newVal) {
      if (newVal) {
        this.scrollToVideoPlayer();
        this.playVideo();
      }
    },
  },
  data() {
    return {
      outdoorServices: [],
      indoorServices: [
        {
          title: "House Cleaning",
          desc: "Coming This Fall",
          icon: require("../assets/images/house-cleaning.svg"),
        },
        {
          title: "Snow Removal",
          desc: "Coming This Winter",
          icon: require("../assets/images/snow-removal.svg"),
        },
      ],
      myCollectionData: [],
      loading: true,
      error: null,
      isOpen: false,
    };
  },
  mounted() {
    this.loading = true;
    this.fetchOutdoorServices();
    if (this.autoplay) {
      setTimeout(() => {
        this.scrollToVideoPlayer();
      }, [1000]);
    }
  },
  methods: {
    navigateToService(service) {
      const slug = service.title
        .toLowerCase()
        .replace(/[^\w ]+/g, "")
        .replace(/ +/g, "-");

      this.$router
        .push({
          name: "ServiceDetails",
          params: { id: slug },
        })
        .catch((err) => {
          console.error("Navigation error:", err);
        });
    },
    async fetchOutdoorServices() {
      this.loading = true;
      this.error = null;

      try {
        const docSnap = await getDoc(
          doc(db, "admin-data", "getOutdoorServices")
        );

        if (docSnap.exists()) {
          this.outdoorServices = this.formatServices(
            docSnap.data().outdoorServices
          );
        } else {
          const colSnap = await getDocs(
            collection(db, "admin-data/getOutdoorServices")
          );
          this.outdoorServices = this.formatServices(
            colSnap.docs.map((d) => d.data())
          );
        }
      } catch (err) {
        this.error = this.getFirestoreError(err);
        console.error("Fetch error:", err);
      } finally {
        this.loading = false;
        // console.log("this.outdoorServices >>>", this.outdoorServices)
      }
    },
    formatServices(services) {
      return [
        {
          id: "",
          title: "Lawn Mowing",
          desc: "",
          icon: `<svg width="48" height="46" viewBox="0 0 48 46" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.737612 23.8615C2.153 24.9076 3.26069 26.1384 4.18377 27.5538C6.09146 30.4769 7.16838 33.7384 7.99915 37.0923C8.70684 39.8923 9.10684 42.7538 9.38377 45.6461H20.8915C20.8915 41.4615 20.0607 37.523 17.9068 33.8615C15.5992 29.923 12.3068 27.0615 8.33761 24.9384C6.42226 23.9179 4.39964 23.113 2.30684 22.5384C1.72223 22.3846 1.19915 22.323 0.737612 22.9999C0.768382 23.0307 0.460689 23.6461 0.737612 23.8615Z" fill="url(#paint0_linear_8038_236172)"/>
<path d="M5.81579 0.599956C8.15425 1.33842 10.2466 2.69226 12.2773 4.07688C17.8158 7.92303 22.0619 12.9384 25.1389 18.9384C28.4004 25.3384 30.0927 32.1692 30.585 39.3076C30.7389 41.4 30.7696 43.523 30.8619 45.6461H22.2466C22.0927 43.8615 22.0619 42.0153 21.7235 40.2615C20.585 34.0769 17.2927 29.2461 12.2773 25.5538C11.9081 25.2769 11.785 25.0307 11.785 24.6C11.785 21.4923 11.5081 18.3846 10.8927 15.3384C9.87733 10.2923 8.15425 5.61534 4.27733 1.98457C3.9081 1.64611 3.9081 1.1538 4.21579 0.723033C4.4004 0.476879 4.7081 0.353802 4.98502 0.41534C5.2004 0.41534 5.44656 0.476879 5.81579 0.599956Z" fill="url(#paint1_linear_8038_236172)"/>
<path d="M27.5687 20.8769C26.9841 19.7076 26.5533 18.6307 25.9687 17.6461C24.9841 15.9538 23.9379 14.2615 22.8918 12.5999C22.7071 12.323 22.6456 12.1076 22.8302 11.7999C24.6456 8.75379 26.7687 6.01533 29.7841 4.07687C31.5995 2.93841 33.5379 2.29225 35.6918 2.23071C36.1533 2.23071 36.5533 2.26148 36.7995 2.72302C37.0456 3.15379 36.9225 3.52302 36.6764 3.92302C35.1379 6.53841 33.8764 9.30764 32.8302 12.1692C32.3995 13.3692 31.9995 14.6307 31.5995 15.8615C31.5379 16.0153 31.4456 16.1692 31.3533 16.323C30.1225 17.7692 28.8918 19.2153 27.661 20.6307C27.661 20.6615 27.6302 20.7538 27.5687 20.8769Z" fill="url(#paint2_linear_8038_236172)"/>
<path d="M47.1374 28.6923C45.599 31.3077 44.3374 34.0769 43.2913 36.9384C42.8605 38.1384 42.4605 39.4 42.0605 40.6307C42.0605 40.6615 42.0297 40.723 41.999 40.8154C41.7221 41.4615 40.799 43.6769 40.399 45.5846L38.1836 45.7077V45.3077C38.2144 44.7846 38.2451 44.2615 38.2451 43.7692C38.3067 42.3846 38.3682 40.9692 38.4913 39.5846C38.8297 35.8307 39.4451 32.2307 40.4297 28.7538C42.1836 27.6769 44.0913 27.0615 46.1836 27C46.6451 27 47.0451 27.0307 47.2913 27.4615C47.5067 27.8923 47.3836 28.2923 47.1374 28.6923Z" fill="url(#paint3_linear_8038_236172)"/>
<path d="M45.5672 13.2769C44.8287 12.5385 43.9364 12.8154 43.1056 12.9077C37.3518 13.4615 33.1056 16.5077 29.7518 21.0308C29.2902 21.6462 28.6749 22.2615 28.5518 22.9385C28.4287 23.5846 28.8902 24.3231 29.1056 25.0308C30.4902 29.2462 31.3825 33.5539 31.7518 37.9846C31.9672 40.5385 31.9979 43.0923 32.121 45.6462H36.921C37.0133 43.5846 37.0749 41.5231 37.2595 39.4923C37.9364 31.8308 39.8749 24.5077 43.4441 17.6769C43.9979 16.6308 44.6441 15.6154 45.2595 14.6C45.2595 14.6 45.8441 13.6769 45.5672 13.2769Z" fill="url(#paint4_linear_8038_236172)"/>
<defs>
<linearGradient id="paint0_linear_8038_236172" x1="-11.7089" y1="13.8898" x2="31.2798" y2="56.8784" gradientUnits="userSpaceOnUse">
<stop stop-color="#64DD17"/>
<stop offset="1" stop-color="#1F8C02"/>
</linearGradient>
<linearGradient id="paint1_linear_8038_236172" x1="-2.49283" y1="4.67473" x2="40.4958" y2="47.6633" gradientUnits="userSpaceOnUse">
<stop stop-color="#64DD17"/>
<stop offset="1" stop-color="#1F8C02"/>
</linearGradient>
<linearGradient id="paint2_linear_8038_236172" x1="11.309" y1="-9.12806" x2="54.2976" y2="33.8606" gradientUnits="userSpaceOnUse">
<stop stop-color="#64DD17"/>
<stop offset="1" stop-color="#1F8C02"/>
</linearGradient>
<linearGradient id="paint3_linear_8038_236172" x1="4.18053" y1="-2.00003" x2="47.1691" y2="40.9889" gradientUnits="userSpaceOnUse">
<stop stop-color="#64DD17"/>
<stop offset="1" stop-color="#1F8C02"/>
</linearGradient>
<linearGradient id="paint4_linear_8038_236172" x1="5.79147" y1="-3.612" x2="48.7801" y2="39.3769" gradientUnits="userSpaceOnUse">
<stop stop-color="#64DD17"/>
<stop offset="1" stop-color="#1F8C02"/>
</linearGradient>
</defs>
</svg>
`,
          is_enable: true,
        },
        ...(services || []).map((service) => ({
          id: service.id || "",
          title: service.name || service.title || "",
          desc: service.description || service.desc || "",
          icon: service.icon || "",
          is_enable: service.is_enable || "",
        })),
      ];
    },
    getFirestoreError(err) {
      const errors = {
        "permission-denied": "No access permissions",
        unavailable: "Network connection failed",
        default: "Failed to load services",
      };
      return errors[err.code] || errors.default;
    },
    scrollToVideoPlayer() {
      const video = this.$refs.videoPlayer;
      if (video) {
        video.scrollIntoView({ behavior: "smooth", block: "center" });

        const video2 = document.getElementById('videoPlayer');
      if (video2) {
        const playPromise = video2.play();
        if (playPromise !== undefined) {
          playPromise
            .then(() => {
              console.log("Video is playing");
            })
            .catch((error) => {
              console.log("Autoplay was prevented:", error);
            });
        }
      }
      }
    },
    toggleDropdown() {
      console.log("hiiiiiiii :>> ");
      this.isOpen = !this.isOpen;
    },
    openDropdown() {
      this.isOpen = true;
    },
    closeDropdown() {
      this.isOpen = false;
    },
    selectItem(item) {
      this.$emit("selected", item);
      this.closeDropdown();
    },
    onContactUs() {
      this.$router
        .push({
          name: "Contact",
        })
        .catch((err) => {
          console.error("Navigation error:", err);
        });
    },
  },
};
</script>

<style scoped lang="scss">
@use "@/assets/styles/components/help";
@use "@/assets/styles/components/skeleton";
</style>
